import Image from "next/image"
import styles from "./form-incut-status.module.scss"
import successIcon from "/public/assets/icons/icn-success.svg";
import failureIcon from "/public/assets/icons/icn-error.svg"

type FormSubmitStatus = 'success' | 'failure';

interface FormSubmitStatusProps {
    status: FormSubmitStatus;
}

const TITLES = new Map<FormSubmitStatus, string>([
    ['success', 'Application sent'],
    ['failure', 'Application not sent']
]);

const ICONS = new Map<FormSubmitStatus, string>([
    ['success', successIcon],
    ['failure', failureIcon]
]);

const TEXT = new Map<FormSubmitStatus, string>([
    ['success', 'Thank you! Your checklist in on the way to your email.'],
    ['failure', 'Unfortunately, something went wrong. Please try again later.']
]);

export default function FormIncutStatus({status}: FormSubmitStatusProps) {

    return (
        <div className={styles.container}>
            <div className={`${styles.icon}  ${status === 'success' ? styles.success : styles.error}`}>
                <Image alt="image" width="24px" height="18px" src={ICONS.get(status)!}/>
            </div>
            <div className={styles.title}>
                {TITLES.get(status)!}
            </div>
            <div className={styles.text}>
                {TEXT.get(status)!}
            </div>
        </div>
    )
}
